import React from 'react';

import { Layout, UtilityMenuBanner } from '../../v2/components/common';
import { Steps } from '../../v2/components/homeowner-design/steps';
import { LooksLike } from '../../v2/components/homeowner-design/looksLike';
import { Hero } from '../../v2/components/homeowner-design/hero/Hero';
import { SeeOutcome } from '../../v2/components/common/homeowner/seeOutcome';
import { Inspired } from '../../v2/components/homeowner-design/inspired';
import { HOMEOWNER_DESIGN_RETHINK_SLIDES } from '../../v2/constants';
import Rethink from '../../v2/components/common/rethink-carousel';
import FacebookPixel from '../../v2/components/common/layout/FacebookPixel';

const HomeownerRenderings: React.FC = () => (
  <Layout
    title="3D Home Renderings - HOVER Design"
    description="See it before you buy it with Hover Design. You can bring design ideas to life with a beautifully rendered, photo-realistic vision."
    buttonType="SCHEDULE_A_DEMO"
    bannerElement={<UtilityMenuBanner />}
  >
    <FacebookPixel />
    <Hero />
    <Inspired />
    <Steps />
    <Rethink slides={HOMEOWNER_DESIGN_RETHINK_SLIDES} />
    <LooksLike />
    <SeeOutcome />
  </Layout>
);

export default HomeownerRenderings;
